import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { AdminAuthStoreProvider } from '~admin/store/admin-auth-store-provider';
import { AppContainer } from '~admin/view/components/app-container.component';
import { muiTheme, theme } from '~web/view/theme';

export const Root: React.FunctionComponent = () => (
  <ThemeProvider theme={theme}>
    <MuiThemeProvider theme={muiTheme}>
      <AdminAuthStoreProvider>
        <AppContainer />
      </AdminAuthStoreProvider>
    </MuiThemeProvider>
  </ThemeProvider>
);



// WEBPACK FOOTER //
// ./view/root.tsx